import API from "./api";

export const PostDocument = (configUrl: string, file: any) =>
  API.post(`${configUrl}api/Blob`, file);

export const DeleteDocument = (configUrl: string, blobId: number) =>
  API.delete(`${configUrl}api/Blob/${blobId}`);
